<div class="building-type-filter">
  <div class="building-type-filter-ctn">
    <section class="filter-all" (click)="$event.stopPropagation()">
      <mat-checkbox [checked]="isAllSelected" (change)="toggleSelect($event.checked)">Alle</mat-checkbox>
    </section>

    <section class="tree">
      <mat-tree [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle matTreeNodePadding (click)="$event.stopPropagation()">
          <mat-checkbox class="building-node" [checked]="checklistSelection.isSelected(node)" (change)="buildingLeafItemSelectionToggle(node)">
            <div class="name">
              <span>{{ node.buildingName }}</span>
            </div>
            <div class="address">
              <span>
                <span class="fa fa-map-marker"></span>
                {{ node.address }}
              </span>
            </div>
          </mat-checkbox>
        </mat-tree-node>

        <mat-tree-node *matTreeNodeDef="let node; when: hasChild" matTreeNodePadding (click)="$event.stopPropagation()">
          <div class="parent-node" matTreeNodeToggle>
            <span
              class="fa expand-icon"
              [ngClass]="{
                'fa-chevron-down': treeControl.isExpanded(node),
                'fa-chevron-right': !treeControl.isExpanded(node)
              }"
            ></span>
          </div>
          <mat-checkbox
            [checked]="descendantsAllSelected(node)"
            [indeterminate]="descendantsPartiallySelected(node)"
            (change)="buildingItemSelectionToggle(node)"
          >
            <span class="buiding-type-name">{{ node.buildingTypeName }}</span>
          </mat-checkbox>
        </mat-tree-node>
      </mat-tree>
    </section>
  </div>
</div>
